// Pré-requis officiels & conditions d'intégration pour chaque formation 2 & 3 roues
// À afficher dans /formation (vue élève) — sources : Service-Public.fr, Code de la route 2026

export const formationsRequirements = {
  'AM / BSR': {
    color: '#18794e',
    soft: '#eaf8ef',
    icon: 'Sprout',
    tagline: 'Première étape vers la route pour les 14 ans et plus.',
    vehicules: [
      { iconKey: 'Bike', label: 'Cyclomoteur ≤ 50 cm³', detail: 'Scooter, mobylette, 2 roues ≤ 45 km/h' },
      { iconKey: 'Car', label: 'Voiturette (quadricycle léger)', detail: 'Type Aixam, Ligier, Microcar — sans permis' }
    ],
    age: {
      min: 14,
      text: '14 ans minimum pour conduire un cyclomoteur ou une voiturette.'
    },
    prerequis: [
      { icon: 'School', label: 'ASSR 1 ou ASSR 2', detail: 'Attestation Scolaire de Sécurité Routière (obtenue au collège en 5ème ou 3ème).' },
      { icon: 'FileCheck', label: 'Ou ASR', detail: 'Attestation de Sécurité Routière (si non scolarisé, passée en auto-école).' }
    ],
    duree: {
      total: '8 heures minimum',
      detail: 'Formation généralement répartie sur 2 jours consécutifs.',
      breakdown: [
        { h: '2 h', label: 'Théorie (règles + risques)' },
        { h: '2 h', label: 'Hors circulation (plateau)' },
        { h: '4 h', label: 'Circulation accompagnée' }
      ]
    },
    examen: {
      hasExam: false,
      text: 'Pas d\'examen final. Validation directe par l\'auto-école + demande du permis AM via l\'ANTS.'
    },
    autorisations: [
      'Conduire seul un cyclomoteur 50 cm³ ou une voiturette à 14 ans',
      'Transport de passager autorisé si le cyclomoteur dispose d\'une 2ᵉ place homologuée (selle + repose-pieds) et que le passager porte un casque',
      'Port du casque homologué + gants obligatoires'
    ],
    conseilsEleve: [
      'Ne roule jamais sans casque ni gants, même pour 500 m.',
      'Le 50 cm³ ne protège pas — tu es aussi vulnérable qu\'en moto.',
      'La pression du groupe peut te mettre en danger : tu décides seul.'
    ],
    coutIndicatif: 'Environ 150 à 350 € selon l\'école de conduite.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — assure les dommages causés aux tiers. Obligatoire, sans elle = circulation illégale.',
        'Tout véhicule (cyclomoteur ou voiturette) doit avoir son propre contrat d\'assurance.'
      ],
      conseillee: [
        'Vol & incendie — très utile en ville (risque élevé sur 50 cm³).',
        'Dommages tous accidents (tous risques) — couvre les dégâts sur ton véhicule.',
        'Garantie conducteur — couvre tes propres blessures même si tu es responsable.'
      ],
      coutAnnuel: 'Environ 200 à 600 €/an (selon âge, zone géographique, véhicule).',
      astuces: [
        'Jeune conducteur = surprime possible les 2-3 premières années.',
        'Antivol homologué SRA → réduction cambriolage.',
        'Stationnement en garage fermé → réduction possible.'
      ]
    }
  },

  'A1': {
    color: '#1d4ed8',
    soft: '#eef5ff',
    icon: 'Bike',
    tagline: 'Ta première vraie moto 125 cm³ dès 16 ans.',
    vehicules: [
      { iconKey: 'Bike', label: 'Moto légère ≤ 125 cm³', detail: 'Puissance maximale 11 kW (15 ch) · rapport poids/puissance ≤ 0,1 kW/kg' },
      { iconKey: 'Truck', label: 'Tricycle à moteur ≤ 15 kW', detail: 'Sous conditions — voir la catégorie L5e pour les plus puissants' }
    ],
    age: {
      min: 16,
      text: '16 ans minimum pour passer le permis A1.'
    },
    prerequis: [
      { icon: 'School', label: 'ASSR 2 obligatoire', detail: 'Pour toute personne née après 1988 (sauf si déjà titulaire d\'un permis).' },
      { icon: 'FileCheck', label: 'ETM — Code moto', detail: 'Épreuve théorique moto obligatoire depuis le 1er mars 2020 (aucune dispense possible) : 40 questions, 35 bonnes minimum, valable 5 ans.' }
    ],
    duree: {
      total: '20 heures conseillées (pas de minimum légal)',
      detail: 'En pratique, la plupart des écoles proposent 20 h pour arriver prêt aux épreuves.',
      breakdown: [
        { h: '8 h', label: 'Plateau (hors circulation)' },
        { h: '12 h', label: 'Circulation (route)' }
      ]
    },
    examen: {
      hasExam: true,
      text: 'Examen en 2 parties : épreuve plateau (6 manœuvres) puis épreuve circulation (~40 min avec inspecteur).',
      parts: ['Plateau : slalom, déplacement moto sans moteur, lent, rapide, freinage d\'urgence, évitement', 'Circulation : trajectoires, anticipation, respect du code']
    },
    autorisations: [
      'Conduire une moto ≤ 125 cm³ en solo',
      'Passer au permis A2 après 2 ans (passerelle A2)',
      'Port équipement obligatoire : casque + gants homologués CE'
    ],
    conseilsEleve: [
      'Le 125 n\'est pas « petit » : même vulnérabilité qu\'une plus grosse cylindrée.',
      'Travaille le regard dès le début : la moto va là où tu regardes.',
      'Prends ton temps en plateau — c\'est la base de toute ta conduite.'
    ],
    coutIndicatif: 'Environ 700 à 1 300 € selon la région et l\'école.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — indispensable pour circuler.',
        'Carte verte à jour + attestation d\'assurance sur la moto.'
      ],
      conseillee: [
        'Vol + incendie — indispensable en zone urbaine (cible fréquente).',
        'Dommages tous risques — répare ta moto même sans tiers identifié.',
        'Garantie du conducteur — prend en charge tes propres blessures.',
        'Équipement assuré (casque, blouson airbag) — option à souscrire.'
      ],
      coutAnnuel: 'Environ 300 à 800 €/an (jeune conducteur souvent 600+).',
      astuces: [
        'Bonus jeune conducteur : parfois 15-25 % la 1ère année.',
        'Antivol homologué SRA obligatoire pour la garantie vol.',
        'Carrosserie/sacoche non assurée par défaut — lire les exclusions.'
      ]
    }
  },

  'A2': {
    color: '#f59e0b',
    soft: '#fff7ed',
    icon: 'Gauge',
    tagline: 'La porte d\'entrée vers la moyenne cylindrée dès 18 ans.',
    vehicules: [
      { iconKey: 'Bike', label: 'Moto ≤ 35 kW (47,5 ch)', detail: 'Rapport poids/puissance ≤ 0,2 kW/kg · bride possible sur des motos plus puissantes' },
      { iconKey: 'Truck', label: 'Tricycle à moteur > 15 kW', detail: 'Accès progressif aux tricycles à partir de 21 ans en A2' }
    ],
    age: {
      min: 18,
      text: '18 ans minimum pour passer le permis A2.'
    },
    prerequis: [
      { icon: 'School', label: 'ASSR 2', detail: 'Obligatoire si né après 1988 et sans permis auto.' },
      { icon: 'FileCheck', label: 'ETM — Code moto', detail: 'Épreuve théorique moto obligatoire depuis le 1er mars 2020 : 40 questions, 35 bonnes minimum, valable 5 ans. Plus aucune dispense pour les titulaires du permis B.' }
    ],
    duree: {
      total: '20 heures minimum obligatoires',
      detail: 'Durée légale minimale — beaucoup d\'élèves ont besoin de plus en pratique.',
      breakdown: [
        { h: '8 h', label: 'Plateau (hors circulation)' },
        { h: '12 h', label: 'Circulation (route)' }
      ]
    },
    examen: {
      hasExam: true,
      text: 'Même format que l\'A1 : plateau puis circulation. Niveau d\'exigence plus élevé (vitesse, anticipation, gestion de la puissance).',
      parts: ['Plateau : 6 manœuvres incluant freinage d\'urgence et évitement', 'Circulation : ~40 min en conditions réelles avec inspecteur']
    },
    autorisations: [
      'Conduire toute moto ≤ 35 kW en solo',
      'Accès à la passerelle A après 2 ans de permis A2',
      'Port équipement obligatoire : casque + gants CE'
    ],
    conseilsEleve: [
      'L\'A2 est la formation la plus demandée — prépare-toi sérieusement.',
      'Anticipation > vitesse : c\'est ce que l\'inspecteur évalue vraiment.',
      'Le stress en examen est normal : respire, visualise, fais comme à l\'entraînement.'
    ],
    coutIndicatif: 'Environ 800 à 1 500 € selon la région et l\'école.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — couverture minimale légale.',
        'Attestation + vignette verte obligatoires sur le véhicule.'
      ],
      conseillee: [
        'Dommages tous risques (fortement recommandé pour une moyenne cylindrée).',
        'Vol + incendie (cible de choix en ville).',
        'Garantie conducteur (capital décès + IPP).',
        'Assistance dépannage 0 km (panne, accident, vol).',
        'Équipement (casque, blouson airbag, combinaison).'
      ],
      coutAnnuel: 'Environ 400 à 1 000 €/an (selon véhicule, âge, zone).',
      astuces: [
        'Jeune conducteur : comparer au moins 3 assureurs spécialisés moto.',
        'Moto bridée A2 → prime souvent réduite vs même modèle débridé.',
        'Conservez factures et photos de l\'équipement pour faire valoir la garantie.'
      ]
    }
  },

  'Formation 125 (B→A1)': {
    color: '#db2777',
    soft: '#fdf2f8',
    icon: 'RefreshCw',
    tagline: 'Passer de la voiture à la 125 cm³ — une équivalence rapide pour les conducteurs B.',
    vehicules: [
      { iconKey: 'Bike', label: 'Moto légère ≤ 125 cm³', detail: 'Puissance maximale 11 kW (15 ch) · rapport poids/puissance ≤ 0,1 kW/kg' },
      { iconKey: 'Bike', label: 'Scooter 125 cm³', detail: 'Même catégorie que le permis A1 (équivalence)' }
    ],
    age: {
      min: 18,
      text: '18 ans minimum (puisqu\'il faut 2 ans de permis B, obtenu à 18 ans minimum).'
    },
    prerequis: [
      { icon: 'Award', label: 'Permis B ≥ 2 ans', detail: 'Le permis voiture doit avoir été obtenu depuis au moins 2 ans.' },
      { icon: 'Calendar', label: 'Possible 1 mois avant', detail: 'La formation peut être suivie dans le mois précédant les 2 ans du permis B.' },
      { icon: 'FileCheck', label: 'Aucun examen théorique', detail: 'Pas d\'ETM, pas de code moto à repasser.' }
    ],
    duree: {
      total: '7 heures obligatoires',
      detail: 'Formation continue, généralement sur 1 journée.',
      breakdown: [
        { h: '1 h', label: 'Théorie (vulnérabilité + équipement)' },
        { h: '3 h', label: 'Hors circulation (plateau)' },
        { h: '3 h', label: 'Circulation (urbain + route)' }
      ]
    },
    examen: {
      hasExam: false,
      text: 'Pas d\'examen final. Attestation délivrée par l\'école — valable immédiatement, à conserver avec le permis B en cas de contrôle.'
    },
    autorisations: [
      'Conduire une moto ou un scooter ≤ 125 cm³',
      'Passer gratuitement du permis B au 2 roues',
      'Port équipement obligatoire : casque + gants homologués CE'
    ],
    conseilsEleve: [
      '« À moto, tu n\'as plus de carrosserie » — ta vulnérabilité change tout.',
      'Tes réflexes de conducteur voiture peuvent te piéger : freiner en virage, rester au milieu, oublier l\'angle mort.',
      'Investis dans un bon équipement : casque, gants, blouson, pantalon, chaussures montantes.'
    ],
    coutIndicatif: 'Environ 250 à 400 €.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — même régime que pour l\'A1/A2.',
        'Distincte du contrat voiture : la moto/scooter 125 a son propre contrat.'
      ],
      conseillee: [
        'Dommages tous risques (si véhicule neuf ou valeur > 2 000 €).',
        'Vol + incendie (scooter = cible fréquente).',
        'Garantie conducteur corporelle.',
        'Assistance 0 km (cruciale en cas de panne).'
      ],
      coutAnnuel: 'Environ 200 à 600 €/an (moins cher qu\'une A2).',
      astuces: [
        'Conducteurs > 30 ans avec bonus auto : tarifs préférentiels chez certains assureurs.',
        'Certaines assurances multi-véhicules regroupent auto + moto 125 avec remise.',
        'Antivol SRA obligatoire pour la garantie vol.'
      ]
    }
  },

  'Passerelle A2 vers A': {
    color: '#cf2031',
    soft: '#fff5f5',
    icon: 'Zap',
    tagline: 'Accède à toutes les motos sans limitation de puissance.',
    vehicules: [
      { iconKey: 'Bike', label: 'Toutes motos', detail: 'Plus de limitation de puissance ni de cylindrée' },
      { iconKey: 'Truck', label: 'Tous tricycles à moteur', detail: 'Y compris catégorie L5e de forte puissance' }
    ],
    age: {
      min: 20,
      text: '20 ans minimum (puisqu\'il faut 2 ans de permis A2, obtenu à 18 ans minimum).'
    },
    prerequis: [
      { icon: 'Award', label: 'Permis A2 ≥ 2 ans', detail: 'Indispensable — la formation peut être suivie dans le mois qui précède les 2 ans.' },
      { icon: 'CheckCircle2', label: 'Aucun examen théorique', detail: 'Pas de repassage du code ni de l\'ETM.' }
    ],
    duree: {
      total: '7 heures obligatoires',
      detail: 'Formation continue, généralement sur 1 journée.',
      breakdown: [
        { h: '2 h', label: 'Théorie (accidentologie + risques)' },
        { h: '2 h', label: 'Hors circulation (plateau)' },
        { h: '3 h', label: 'Circulation' }
      ]
    },
    examen: {
      hasExam: false,
      text: 'Pas d\'examen. Attestation de formation délivrée par l\'école → transformation permis A sur l\'ANTS.'
    },
    autorisations: [
      'Conduire toutes motos (aucune limite de puissance ou de cylindrée)',
      'Transport de passager sans restriction',
      'Port équipement obligatoire : casque + gants CE'
    ],
    conseilsEleve: [
      'L\'accès aux gros cubes = nouvelle prudence : le danger change d\'échelle.',
      'Ne te fie pas à tes 2 ans d\'A2 — le couple des grosses cylindrées surprend.',
      'Reprends les fondamentaux : regard, trajectoire, anticipation restent les piliers.'
    ],
    coutIndicatif: 'Environ 250 à 400 €.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — identique à l\'A2.',
        'Déclare le changement de catégorie de permis à ton assureur pour éviter la déchéance.'
      ],
      conseillee: [
        'Tous risques fortement recommandé (valeur élevée des grosses cylindrées).',
        'Vol + incendie + équipement.',
        'Garantie conducteur avec capital corporel renforcé.',
        'Protection juridique moto.'
      ],
      coutAnnuel: 'Environ 500 à 1 500 €/an (grosses cylindrées = primes élevées).',
      astuces: [
        'Les hypersportives et Supermotards ont des primes beaucoup plus élevées.',
        'Kilométrage limité (5 000 km/an) → tarif réduit chez plusieurs assureurs.',
        'Formation + 2 ans de permis A2 = profil rassurant → négocier.'
      ]
    }
  },

  'L5e / Ryker 600-900': {
    color: '#7c3aed',
    soft: '#f4effd',
    icon: 'Truck',
    tagline: 'Le tricycle à moteur — Can-Am Ryker et autres L5e.',
    vehicules: [
      { iconKey: 'Truck', label: 'Ryker 600 (L5e)', detail: 'Tricycle à moteur, puissance modérée' },
      { iconKey: 'Truck', label: 'Ryker 900 (L5e)', detail: 'Tricycle à moteur, plus coupleux et vif — même catégorie L5e' },
      { iconKey: 'Truck', label: 'Autres tricycles L5e', detail: 'Spyder, Niken (selon homologation) et assimilés' }
    ],
    age: {
      min: 21,
      text: '21 ans minimum pour un L5e de puissance > 15 kW (la majorité des Ryker). 18 ans possible pour L5e ≤ 15 kW.'
    },
    prerequis: [
      { icon: 'Award', label: 'Permis B ≥ 2 ans', detail: 'Le permis voiture doit avoir été obtenu depuis au moins 2 ans.' },
      { icon: 'Calendar', label: 'Possible 1 mois avant', detail: 'La formation peut être suivie dans le mois précédant les 2 ans du permis B.' },
      { icon: 'FileCheck', label: 'Aucun examen théorique', detail: 'Pas d\'ETM, pas de code moto.' }
    ],
    duree: {
      total: '7 heures obligatoires',
      detail: 'Formation pratique encadrée, généralement sur 1 journée.',
      breakdown: [
        { h: '2 h', label: 'Théorie (L5e, équipement, risques)' },
        { h: '2 h', label: 'Hors circulation (gabarit, trajectoires)' },
        { h: '3 h', label: 'Circulation (urbain + route + carrefour à sens giratoire)' }
      ]
    },
    examen: {
      hasExam: false,
      text: 'Pas d\'examen final. Attestation de formation délivrée — à conserver avec le permis B en cas de contrôle.'
    },
    autorisations: [
      'Conduire un tricycle L5e (Ryker 600/900 inclus)',
      'Transport de passager selon le véhicule (vérifier la carte grise)',
      'Port équipement : casque obligatoire, gants CE fortement recommandés'
    ],
    conseilsEleve: [
      'Le Ryker ne s\'incline pas comme une moto : la trajectoire se pilote au guidon.',
      'Stabilité ≠ invulnérabilité — tu restes vulnérable comme un motard.',
      'Ralentis AVANT le virage, regarde la sortie, tiens compte de la largeur du train avant.'
    ],
    coutIndicatif: 'Environ 250 à 400 €.',
    assurance: {
      obligatoire: [
        'Responsabilité Civile (RC) — indispensable.',
        'Contrat spécifique tricycle L5e : vérifier la catégorie sur la carte grise.'
      ],
      conseillee: [
        'Tous risques (le Ryker est cher, réparation coûteuse).',
        'Vol + incendie.',
        'Garantie conducteur renforcée (vulnérabilité malgré 3 roues).',
        'Assistance 0 km (pièces parfois longues à obtenir chez Can-Am).'
      ],
      coutAnnuel: 'Environ 400 à 900 €/an.',
      astuces: [
        'Tous les assureurs n\'acceptent pas les L5e → marchés spécialisés.',
        'Le tarif dépend beaucoup du Ryker 600 vs 900 (prime plus élevée pour 900).',
        'Permis B depuis longtemps + formation 7h = profil avantageux.'
      ]
    }
  }
};
